import { DesignSystem } from 'dragonmouse-shared/interfaces';
import ActiveDesignSystemSection from '../ActiveDesignSystemSection';
import { DsPickerSelection } from '../index';
import * as S from './styles';

interface ActiveDsPanelProps {
	selection: DsPickerSelection;
	designSystems: DesignSystem[];
	isMobile: boolean;
	onSelect: (designSystem: DesignSystem | null) => Promise<void>;
	onUpgrade?: () => Promise<void>;
	onClose: () => void;
	onShowLinkPanel: () => void;
}

const ActiveDsPanel = ({
	selection,
	designSystems,
	isMobile,
	onSelect,
	onUpgrade,
	onClose,
	onShowLinkPanel,
}: ActiveDsPanelProps) => {
	const activeDesignSystem = designSystems.find((ds) => ds.id === selection.id);

	if (!activeDesignSystem) return null;

	const { linkedVersion, latestVersion } = selection;

	// Calculate updatePendingState internally
	const updatePendingState: 'publishing' | 'ready' | null = (() => {
		if (!latestVersion) return null;
		const promptStatus = latestVersion.manifest?.promptGenerationStatus;
		if (promptStatus === 'pending' || promptStatus === 'generating') {
			return 'publishing';
		}
		if (
			linkedVersion &&
			latestVersion &&
			linkedVersion.versionNumber < latestVersion.versionNumber &&
			promptStatus === 'complete'
		) {
			return 'ready';
		}
		return null;
	})();

	const handleLinkNew = () => {
		onShowLinkPanel();
	};

	return (
		<>
			<ActiveDesignSystemSection
				activeDesignSystem={activeDesignSystem}
				linkedVersion={linkedVersion ?? null}
				latestVersion={latestVersion ?? null}
				isMobile={isMobile}
				onLinkDs={onSelect}
				onUpgrade={onUpgrade}
				onClose={onClose}
				updatePendingState={updatePendingState}
			/>
			<S.SectionDivider />
			<S.DropdownSection>
				<S.ChangeLink onClick={handleLinkNew}>
					<S.ChangeLinkText>Switch Design System</S.ChangeLinkText>
					<S.ChangeLinkArrow>→</S.ChangeLinkArrow>
				</S.ChangeLink>
			</S.DropdownSection>
		</>
	);
};

export default ActiveDsPanel;
